<label [class.disabled]="disabled">
  <input
    type="radio"
    [value]="value"
    [checked]="checked"
    (change)="onChange($event)"
    [disabled]="disabled"
    [ngClass]="{ 'squared-radio': radioType === RadioType.SQUARED }"
  />
  {{ label }}
</label>
